import { useReducer, useCallback } from 'react';
import axios from 'axios';
// import getApiToken from "../utils/getApiToken";
//
// const apiToken = getApiToken();

const initialState = {
  loading: false,
  error: null,
  data: null,
  endpoint: null,
  extra: null,
  identifier: null
};

const httpReducer = (currentHttpState, action) => {
  switch (action.type) {
    case 'SEND':
      return {
        loading: true,
        error: null,
        data: null
      };
    case 'RESPONSE':
      return {
        ...currentHttpState,
        loading: false,
        data: action.responseData,
        endpoint: action.endpoint
      };
    case 'ERROR':
      return { loading: false, error: action.errorMessage };
    case 'CLEAR':
      return initialState;
    default:
      throw new Error('Error');
  }
};

const useHttp = () => {
  const [httpState, dispatchHttp] = useReducer(httpReducer, initialState);

  const clear = useCallback(() => dispatchHttp({ type: 'CLEAR' }), []);

  const CancelToken = axios.CancelToken;
  let source;

  const sendRequest = useCallback(
    (url, method, obj, reqIdentifer) => {
      dispatchHttp({ type: 'SEND', identifier: reqIdentifer });
      // console.log('url', url);
      // console.log('params', params);
      // var hdrs = location.hostname.includes('wbstudiotour') ?
        // 'application/json; charset=UTF-8' :
        // 'application/x-www-form-urlencoded; charset=UTF-8'
      let params = [];
      if (obj) {
        for (let [key, value] of Object.entries(obj)) {
          if (typeof value === 'object') value = JSON.stringify(value);
          params.push(`${key}=${value}`);
        }
      }
      params = params.join('&');
      // console.log('params', params);
      const data_format = location.hostname.includes('wbstudiotour') ? params : obj;

      const urlArray = url.split('/');
      const urlArrayLength = urlArray.length;
      const endpoint = urlArray[urlArrayLength-1];

      if (source) source.cancel();
      source = CancelToken.source();
      // console.log('sendRequest url', url);
      axios({
        method: method,
        url: url,
        data: params
      })
        .then(response => {
          // console.log('response', response);
          dispatchHttp({
            type: 'RESPONSE',
            responseData: response.data,
            endpoint: endpoint
          });
        })
        .catch(error => {
          if (!axios.isCancel(error)) {
            console.warn(error.response);
            dispatchHttp({
              type: 'ERROR',
              errorMessage: error.response
            });
          }
          // console.warn(error.response);
        });
    },[]);

  return {
    isLoading: httpState.loading,
    data: httpState.data,
    endpoint: httpState.endpoint,
    error: httpState.error,
    sendRequest: sendRequest,
    reqExtra: httpState.extra,
    reqIdentifer: httpState.identifier,
    clear: clear
  };
};

export default useHttp;
